import React from 'react';
import debounce from '../../lib/debounce';
import Loading from '../../components/Loading';
import ChoicesDates, { AI_TRACKING_CHOICES, WITH_TODAY_CHOICES } from './Choices/Dates';
import FilterOptions from '../../components/FilterOptions';
import { isTrue } from '../../helpers/isTrue';

class Filters extends React.Component {
    constructor(props) {
        super();

        this.state = window.filters.get();

        this.updateFilter = this.updateFilter.bind(this);
        window.gsc_report = props.gsc_report;
        window.filters.bind(this.setState.bind(this));
        this.updateFilter = debounce(this.updateFilter.bind(this), 500);
    }

    updateFilter(field, choice) {
        window.filters.update(choice);
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        const is_from_tools = window.location.pathname.split('/')[1] === 'tools';
        const is_from_ai_tracking = window.location.pathname.split('/')[1] === 'ai-tracking';

        let choices = [];

        if (is_from_ai_tracking) {
            choices = AI_TRACKING_CHOICES;
        } else if (is_from_tools) {
            choices = WITH_TODAY_CHOICES;
        } else {
            choices = ChoicesDates;
        }

        return (
            <>
                <FilterOptions
                    name="dates"
                    choices={choices}
                    default={this.state.dates}
                    onChange={this.updateFilter}
                    gsc_report={this.props.gsc_report}
                    show_all={this.props.show_all}
                    dont_show_date_filter={this.props.dont_show_date_filter}
                    is_from_tools={is_from_tools}
                    is_from_ai_tracking={is_from_ai_tracking}
                    select_by_week={isTrue(this.props.select_by_week)}
                />
            </>
        );
    }
}

export default Filters;
